import React from 'react';

import GlobalColumnFunctions from '~/utils/globalColumnFunctions';
import { formatInternationalTeam } from '~/views/pages/internationalTournament/utils';

import BaseColumnDefinitions, { CreateHeaderCell } from '../baseColumnDefinitions';
import InternationalColumns from '../internationalColumns';

const TOURNAMENT_COLS = [
    BaseColumnDefinitions.INDEX_COL,
    InternationalColumns.TEAM_NAME,
    InternationalColumns.TOURNAMENT_NAME,
];

const GAME_COLS = [
    ...TOURNAMENT_COLS,
    InternationalColumns.SERIES_TITLE,
    InternationalColumns.DATE,
    InternationalColumns.RESULT,
];

const GAME_BOTH_TEAMS_COLS = [
    BaseColumnDefinitions.INDEX_COL,
    {
        accessor: 'homeTeamId',
        disableSortBy: true,
        getProps: GlobalColumnFunctions.getProps,
        Header: CreateHeaderCell('Matchup'),
        Cell: ({ original }) => {
            const { homeTeamName, visitingTeamName } = original;
            return (
                <div>
                    {formatInternationalTeam(visitingTeamName)}
                    <div>at</div>
                    {formatInternationalTeam(homeTeamName)}
                </div>
            );
        },
    },
    InternationalColumns.TOURNAMENT_NAME,
    InternationalColumns.SERIES_TITLE,
    InternationalColumns.DATE,
    InternationalColumns.RESULT,
];

export const teamInternationalColumns = {
    'international-team-most-championships': [
        BaseColumnDefinitions.INDEX_COL,
        InternationalColumns.TEAM_NAME,
        InternationalColumns.TOURNAMENTS_PLAYED,
        InternationalColumns.CHAMPIONSHIP_APPEARANCES,
        InternationalColumns.CHAMPIONSHIPS,
    ],
    'international-team-most-championship-appearances': [
        BaseColumnDefinitions.INDEX_COL,
        InternationalColumns.TEAM_NAME,
        InternationalColumns.TOURNAMENTS_PLAYED,
        InternationalColumns.CHAMPIONSHIP_APPEARANCES,
        InternationalColumns.CHAMPIONSHIPS,
    ],
    'international-most-goals-one-team-tournament': [
        ...TOURNAMENT_COLS,
        BaseColumnDefinitions.GAMES_PLAYED_COL,
        BaseColumnDefinitions.GOALS_COL,
    ],
    'international-most-goals-one-team-game': [...GAME_COLS, BaseColumnDefinitions.GOALS_COL],
    'international-most-goals-one-team-period': [
        ...GAME_COLS,
        InternationalColumns.PERIOD_COL,
        BaseColumnDefinitions.GOALS_COL,
    ],
    'international-most-goals-both-teams-game': [...GAME_BOTH_TEAMS_COLS, InternationalColumns.TOTAL_GOALS_COL],
    'international-most-goals-both-teams-period': [
        ...GAME_BOTH_TEAMS_COLS,
        InternationalColumns.PERIOD_COL,
        InternationalColumns.TOTAL_GOALS_COL,
        InternationalColumns.GOAL_BREAKDOWN,
    ],
    'international-most-power-play-goals-one-team-tournament': [
        ...TOURNAMENT_COLS,
        BaseColumnDefinitions.GAMES_PLAYED_COL,
        BaseColumnDefinitions.POWER_PLAY_GOALS_COL,
    ],
    'international-most-power-play-goals-one-team-game': [...GAME_COLS, BaseColumnDefinitions.POWER_PLAY_GOALS_COL],
    'international-most-power-play-goals-both-teams-game': [
        ...GAME_BOTH_TEAMS_COLS,
        InternationalColumns.TOTAL_PP_GOALS_COL,
        InternationalColumns.GOAL_PP_BREAKDOWN,
    ],
    'international-fastest-two-goals-one-team-game': [
        ...GAME_COLS,
        InternationalColumns.GOAL1(true, false),
        InternationalColumns.GOAL2(true, false),
        InternationalColumns.TIME_BETWEEN_GOALS,
    ],
    'international-fastest-three-goals-one-team-game': [
        ...GAME_COLS,
        InternationalColumns.GOAL1(true, false),
        InternationalColumns.GOAL2(true, false),
        InternationalColumns.GOAL3(true, false),
        InternationalColumns.TIME_BETWEEN_GOALS,
    ],
    'international-fastest-two-goals-both-teams-game': [
        ...GAME_BOTH_TEAMS_COLS,
        InternationalColumns.GOAL1(true, true),
        InternationalColumns.GOAL2(true, true),
        InternationalColumns.TIME_BETWEEN_GOALS,
    ],
    'international-fastest-three-goals-both-teams-game': [
        ...GAME_BOTH_TEAMS_COLS,
        InternationalColumns.GOAL1(true, true),
        InternationalColumns.GOAL2(true, true),
        InternationalColumns.GOAL3(true, true),
        InternationalColumns.TIME_BETWEEN_GOALS,
    ],
    'international-most-shots-on-goal-one-team-game': [...GAME_COLS, BaseColumnDefinitions.SHOTS_COL],
    'international-most-shots-on-goal-one-team-period': [
        ...GAME_COLS,
        InternationalColumns.PERIOD_COL,
        BaseColumnDefinitions.SHOTS_COL,
    ],
    'international-most-shots-on-goal-both-teams-game': [
        ...GAME_BOTH_TEAMS_COLS,
        InternationalColumns.TOTAL_SHOTS_COL,
        InternationalColumns.SHOT_BREAKDOWN,
    ],
    'international-most-shots-on-goal-both-teams-period': [
        ...GAME_BOTH_TEAMS_COLS,
        InternationalColumns.PERIOD_COL,
        InternationalColumns.TOTAL_SHOTS_COL,
        InternationalColumns.SHOT_BREAKDOWN,
    ],
    'international-team-all-time-overtime-games': [
        InternationalColumns.DATE,
        InternationalColumns.TOURNAMENT_NAME,
        InternationalColumns.SERIES_TITLE,
        InternationalColumns.RESULT,
        InternationalColumns.OVERTIME_PERIODS,
        InternationalColumns.OVERTIME_LENGTH,
        InternationalColumns.GAME_WINNING_GOAL_SHOOTER,
    ],
};
